import { Component, Input } from '@angular/core';

import { SmartModalService } from '../../../core/services/smart-modal.service';

@Component({
  selector: 'itpx-privacy-policy-modal',
  template: `
        <div class="content">
          <div [innerHTML]="data.text | translate | keepHtml"></div>
          <div class="last-update" *ngIf="data.lastUpdate">Last Updated: {{data.lastUpdate | isoToDate}}</div>
          <div>
              <input type="checkbox" name="consent" id="consent" [(ngModel)]="consent" />
              <label for="consent">{{'brandedPortal.privacy.updateConsent' | translate}}</label>
              <div class="pull-right">
                  <div class="button-form col-md-12">
                      <button type="button" (click)="onContinue()" class="btn btn-primary" [disabled]="!consent">
                          Continue
                      </button>
                  </div>
              </div>
          </div>
        </div>
    `,
  styleUrls: ['./privacy-policy-modal.component.css']
})
export class PrivacyPolicyModalComponent {

  @Input()
  private data: any;

  private consent = false;

  constructor(private modalService: SmartModalService) { }

  private onContinue() {
    this.modalService.sendResult(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/privacy-policy-modal.component.ts